// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 3,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/AdminApplicationDashboard/GetApplicationDetail/",
            deleteAction: "/api/AdminApplicationDashboard",
            updateAction: "/api/AdminApplicationDashboard",
            createAction: "/api/AdminApplicationDashboard"
        },
        fields: {
            ApplicationId: {
                primaryKey: true,
            },
            // InitiativeCallId: {
            //     required: true,
            //     readonly: true,
            //     type: "ComboBox",
            //     autocomplete: true,
            //     title: "Call",
            // },
            Title: {
                title: "Title",
                type: "TextInput",
                readonly: true,
            },
            Country: {
                title: "Country",
                type: "TextInput",
                readonly: true,
            },
            Address: {
                title: "Address",
                type: "TextInput",
                readonly: true,
            },
            Telephone: {
                title: "Telephone",
                type: "TextInput",
                readonly: true,
            },
            ProjectLeadName: {
                title: "Project Lead Name",
                type: "TextInput",
                readonly: true,
            },
            ProjectLeadJobTitle: {
                title: "Project Lead Job Title",
                type: "TextInput",
                readonly: true,
            },
            ProjectLocation: {
                title: "Project Location",
                type: "TextInput",
                readonly: true,
            },
            OrganisationType: {
                title: "Organisation Type",
                type: "TextInput",
                readonly: true,
            },
            AuthSignaturyJobTitle: {
                title: "Auth Signatury Job Title",
                type: "TextInput",
                readonly: true,
            },
            LegalName: {
                title: "Legal Name",
                type: "TextInput",
                readonly: true,
            },
            ProjectStartDate: {
                title: "Project Start Date",
                type: "TextInput",
                readonly: true,
            },
            ProjectEndDate: {
                title: "Project End Date",
                type: "TextInput",
                readonly: true,
            },
            ProjectDuration: {
                title: "Project Duration",
                type: "TextInput",
                readonly: true,
            },
            TotalProjectBudgect: {
                title: "Total Project Budgect",
                type: "TextInput",
                readonly: true,
            },
            RequestedAmount: {
                title: "Requested Amount",
                type: "TextInput",
                readonly: true,
            },
            OrganisationExperience: {
                title: "Organisation Experience",
                type: "TextArea",
                readonly: true,
            },
            ExecutiveSummary: {
                title: "Executive Summary",
                type: "TextArea",
                readonly: true,
            },
            ProjectOverallObjective: {
                title: "Project Overall Objective",
                type: "TextArea",
                readonly: true,
            },
            ConservationActivities: {
                title: "Conservation Activities",
                type: "TextArea",
                readonly: true,
            },
            ProjectImpact: {
                title: "Project Impact",
                type: "TextArea",
                readonly: true,
            },
            ProjectRationale: {
                title: "Project Rationale",
                type: "TextArea",
                readonly: true,
            },
            ProjectApproachActivities: {
                title: "Project Approach Activities",
                type: "TextArea",
                readonly: true,
            },
            CreatedDate: {
                title: "Created Date",
                type: "Date",
                readonly: true,
                edit: false,
            },
            WorkFlowStatusId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Status"
            },
            Comments: {
                type: "TextArea",
                counter: 100,
                title: "Comments"
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        }
    }
}